module.exports = __webpack_public_path__ + "img/check-list.89062627.svg";